import styled from 'styled-components'
import { motion } from 'framer-motion'
import { device } from '@styles/global/breakpoints'
import { Sentinel } from '@styles/global/fonts'
interface ICardProps {
  cardDescription?: string
  h2Color: string,
  h2HoverColor: string
  shadows: {
    init: string,
    hover: string
  },
  right: boolean
}

export const flashContentVariants = {
  init: (custom: ICardProps) => ({
    rotate: 0,
    y: 0,
    color: custom.h2Color,
    boxShadow: custom.shadows.init,
  }),
  hover: (custom: ICardProps) => ({
    rotate: custom.right ? 8 : -8,
    y: custom.right ? -50 : -50,
    color: custom.h2HoverColor,
    boxShadow: custom.shadows.hover,
  })
}
export const FlashCardLink = styled(motion.a)<{double: string}>`
  position: relative;
  width: 100%;
  max-width: 315px;
  height: 500px;
  margin: 0 auto;
  cursor: pointer;
  display: block;

  @media ${device.tablet}{
    margin: 0 0 0 auto; 
    ${props => props.double === 'true' && `
      &:first-child{
       margin-left: 0;
      }`
    }
  }
  @media ${device.laptop}{
    &:hover{
      cursor: pointer;
      .numberDisplay,
      .dollar,
      .num{
        color: #fff;
      }
    }
  }
  @media ${device.laptopL} {
    ${props => props.double === 'true' ? `
      margin: 0 0 0 30px;
      max-width: 380px;
      `
    :`
      margin: 0 0 0 0;
      max-width: 360px;
    `
} 
    
  }
`

export const FlashCardContent = styled(motion.div)<{right: string}>`
  border-radius: 15px;
  transform-origin: ${props => props.right === 'false' ? 'bottom left' : 'bottom right'};
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  justify-content: flex-end;
  
  h2, p{
    text-align: center;
    
  }
  h2{
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
  }
`
export const FlashCardImg = styled.div`
  position: absolute;
  border-radius: 15px;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  transition: .3s;
  transform: scale(1);
  z-index: 1;
  height: 100%;
  
  .gatsby-image-wrapper{
    height: 100%;
  }
`

export const flashOverlayVariants = {
  init: {
    opacity: 0,
    transition: {
      duration: 0.1,
    },
  },
  hover: {
    opacity: .66,
    transition: {
      duration: 0.1,
    },
  },
}
export const FlashOverlay = styled(motion.div)<{ color: string }>`
  position: absolute;
  opacity: 0;
  background: ${props => props.color};
  height: 100%;
  width: 100%;
  transition: .3s;
  z-index: 1;
`

export const flashInfoVariants = {
  init: {
    y: 0,
  },
  hover: {
    y: -120,
  },
}
export const FlashInfo = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 2;
`

export const FlashPercentageSaved = styled.div<{savingsColor?: string | undefined}>`
  ${Sentinel.black};
  font-style: italic;
  text-align: center;
  font-size: 16px;
  width: 100%;
  padding-top: 0;  
  color: ${props => props.savingsColor ? props.savingsColor : ''};
`
export const FlashPaymentType = styled.div`
  ${Sentinel.semiboldItalic};
  text-align: center;
  font-size: 16px;
  width: 100%;
  padding-top: 15px;  
`

export const flashTaglineVariants = {
  init: {
    y: 0,
    opacity: 0,
    transition: {
      duration: 0,
    },
    color: `#fff`,
  },
  hover: (custom:{
    cardDescription: string | undefined
  }) => ({
    y: -65,
    opacity: 1,
    color: custom.cardDescription ? custom.cardDescription : '#fff',
  }),
}
export const FlashTagline = styled(motion.p)`
  color: #fff;
  font-size: 16px;
  font-style: italic;
  position: absolute;
  bottom: 0;
  padding: 0 30px;
  z-index: 2;
  line-height: 21px;
`

export const flashBuyButtonVariants = {
  init: (custom:any) => ({
    background: custom.customBackground,
    color: '#fff',
    transition: {
      duration: .1,
    },
  }),
  hover: (custom:any) => ({
    background: '#fff',
    color: custom.textColor,
    transition: {
      duration: 0,
    },
  })
}
export const FlashBuyButton = styled(motion.div)`
  position: absolute;
  bottom: -26px;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50px;
  background: ${props => props.theme.highlight.i500};
  text-transform: uppercase;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  outline: none;
  border: none;
  padding: 15px 5px;
  width: 100%;
  max-width: 203px;
  transition: .3s;
  cursor: pointer;
  text-align: center;
`

export const FlashCardBg = styled.div<{customCardBg?: string | undefined}>`
  background: ${props => props.customCardBg ? props.customCardBg : props.theme.backgroundSecondary};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 15px;
`
